import script from "./ContentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentItem.vue?vue&type=script&lang=ts&setup=true"

import "./ContentItem.vue?vue&type=style&index=0&id=492afc99&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492afc99"]])

export default __exports__